/**
 * A no-operation function that does nothing and returns nothing
 * @description Useful as a default value for optional function props or callbacks
 * @returns {void}
 */
export const noop = (): void => {};
